
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(2(086|188|984)|6(639|760|803)|9(324|391|807)|(18|74)89|1545|3916|4414|4896|5154|7875)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
